import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Chatbot from "./Chatbot";
import SourceDocumentsFinder from "./SourceDocumentsFinder";
import SearchBox from "./SearchBox";
import Results from "./Results";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Chatbot />} />
        <Route path="/source_finder" element={<h1>Hello World</h1>} />
        <Route path="/source_finder/search_box" element={<SearchBox />} />
        <Route path="/source_finder/results" element={<Results />} />
      </Routes>
    </Router>
  );
}

export default App;
